<div class="container" style="padding-left: 30px;">
    <h1 style="color: #002b5c; text-transform: none; padding-top: 20px;">Global settings</h1>
</div>